<div class="barcode-container">
  <canvas style="width: 100%" #barcode></canvas>
</div>
